import styled from 'styled-components';
import color from '../../constants/color';
import materialUI from '../../material-UI';

export const Container = styled(materialUI.Card)`
display: flex;
margin: 16px;
flex-direction: column;
background-color: ${color.white};
border-radius: 6px;
`;
export const Input = styled.div`
  display: flex;
  width: 20%;
  align-items: center;
  height: 30px;
`;
export const Header = styled.div`
  display: flex;
  flex-direction: row;
  height: 60px;
  align-items: center;
  padding: 0px 30px 0px 30px;
  justify-content: space-between;
`;
export const Title = styled.div`
  font-size: 1.25em;
  font-family: inter;
`;
export const OnPress = styled(materialUI.IconButton)`
  border: 1px solid #6587FF;
`;
export const Divider = styled(materialUI.Divider)``;
export const ContainerLoading = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
`;
